import { useState } from 'react'
import { Link } from 'react-router-dom'
import { resendVerification } from '../api/client'
import { FactoryLogo } from '../components/FactoryLogo'

export default function CheckEmail() {
  const [resendStatus, setResendStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')
  const [error, setError] = useState('')

  const handleResend = async () => {
    setResendStatus('sending')
    setError('')
    try {
      await resendVerification()
      setResendStatus('sent')
    } catch (err) {
      setResendStatus('error')
      setError(err instanceof Error ? err.message : 'Failed to resend')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <FactoryLogo className="w-16 h-16" />
        </div>

        <div className="rounded-full bg-blue-100 dark:bg-blue-900/20 p-3 w-16 h-16 mx-auto flex items-center justify-center">
          <svg className="w-8 h-8 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Check your email</h2>
        <p className="text-gray-600 dark:text-gray-400">
          We sent a verification link to your email address. Click the link to verify your account.
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-500">
          The link expires in 24 hours.
        </p>

        <div className="pt-4 space-y-3">
          {resendStatus === 'sent' ? (
            <p className="text-sm text-green-600 dark:text-green-400">Verification email resent!</p>
          ) : error ? (
            <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
          ) : null}

          <button
            onClick={handleResend}
            disabled={resendStatus === 'sending' || resendStatus === 'sent'}
            className="text-sm font-medium text-primary-600 hover:text-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {resendStatus === 'sending' ? 'Sending...' : "Didn't receive it? Resend email"}
          </button>

          <div>
            <Link
              to="/dashboard"
              className="text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
            >
              Continue to dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
